import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Dashborad/dashboard.css";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import "react-image-crop/dist/ReactCrop.css";
import { Modal } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { authenticatedRequest } from "../../../config/axios";
import { useEffect } from "react";
import moment from "moment";
import { Button } from "react-bootstrap";
import { RotatingLines } from "react-loader-spinner";

const AnalyticsDetail = (props) => {
  const { t } = useTranslation();
  const [analyticsData, setAnalyticsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.eventId) {
      getAnalyticsDetails();
    }
  }, [props.detailModal]);

  
  const getAnalyticsDetails = async () => {
    try {
      setLoading(true);
      const response = await authenticatedRequest({
        method: "get",
        url: `/admin/analytics/${props.eventId}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if ([200, 201, 202].includes(response.status)) {
        setAnalyticsData(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        open={props.detailModal}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalContent"
      >
        <MDBCard className="modal_card">
          <MDBCardBody>
            <h1>Meeting log</h1>
            <ul style={{ padding: 0 }}>
              {loading ? (
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="72"
                  visible={loading}
                />
              ) : analyticsData.length !== 0 ? (
                analyticsData.map((data, i) => {
                  const formattedDate = `${moment(data.updatedAt).format(
                    "DD.MM.YYYY",
                  )} ${moment(data.updatedAt).format("h:mm:ss a")}`;

                  return (
                    <p className="meetingLogContent" key={i}>
                      {data.eventType} ({formattedDate}) {data?.meetingId ? `meeting Id ${data.meetingId}` : ""}
                    </p>
                  );
                })
              ) : (
                <p className="meetingLogContent">
                  {t("No data")}
                </p>
              )}
            </ul>
            <Button onClick={() => props.handleClose()}>{t("Close")}</Button>
          </MDBCardBody>
        </MDBCard>
      </Modal>
    </div>
  );
};
export default AnalyticsDetail;
